import { render, staticRenderFns } from "./RibbonBar.vue?vue&type=template&id=f7e7dc70&scoped=true&"
import script from "./RibbonBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./RibbonBar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RibbonBar.vue?vue&type=style&index=0&id=f7e7dc70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e7dc70",
  null
  
)

export default component.exports